import React from 'react'
import { OurAppsBreadcrumbBar } from '../../../our-apps-breadcrumb-bar'
import { PayrollProductImage } from '../../../product-image/payroll-product-image'
import CallToActionSection from '../../../call-to-action-section'
import { FeatureSection } from './feature-section'
import { AboutSection } from './about-section'

export default function Payroll() {
  return (
    <>
      <OurAppsBreadcrumbBar title="Payroll" productImage={<PayrollProductImage />} />

      <AboutSection />

      <CallToActionSection />

      <FeatureSection />
    </>
  )
}
